import React from "react";
import { Logo } from "../logo";
import { NavLink } from "react-router-dom";

import './style.css'
import Spacer from "../Spacer";


export const ROUTES = {
  home: '/',
  pricing: '/pricing',
  aiPoweredCyberAttackSimulation: '/ai-powered-cyber-attack-simulation',
  securityAwarenessTrainings: '/security-awareness-trainings',
  emailThreatReportButton: '/email-threat-report-button',
  intelligentThreatResponse: '/intelligent-threat-response',
  gamificationPlatform: '/gamification-platform',
  socialEngineeringPrevention: '/social-engineering-prevention',
  behavioralChange: '/behavioral-change',
  comprehensiveCybersecurity: '/comprehensive-cybersecurity',
  proactiveRiskAssessment: '/proactive-risk-assessment',
  globalWorkforceDefense: '/global-workforce-defense',
  appfraud: '/appfraud',
  achieveAndMaintainRobust: '/achieve-and-maintain-robust',
  whyCyberlift: '/why-cyberlift',
  aiPoweredPlatform: '/ai-powered-platform',
  cyberliftVsCompetitors: '/cyberlift-vs-competitors',
  aboutUs: '/about-us',
  terms: '/terms',
  newsroom: '/newsroom',
  partners: '/partners',
  careers: '/careers',
  securityCompliance: '/security-compliance',
  technologies: '/technologies',
  contacts: '/contacts',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  dpa: '/data-processing-agreement',

}




export const Navigation = ({ theme, style }) => {
  return (
    <div style={style} className={"nav row row-center " + theme}>
      <div className="container1300 row row-center">
        <div className="row row-center" style={{ width: '100%' }}>
          <NavLink to='/'>
            <Logo theme={theme} />
          </NavLink>

          <Spacer />

        </div>

      </div>
    </div>
  )
}